/**
 *
 * AsyncPicker
 *
 */
import { Entity } from 'types/common';
import { FieldHookConfig, useField } from 'formik';
import { IFieldProps } from './FormRender/IFormFieldSetting';
import { EveryDaysPicker } from '../pickers/StaticOptionsPickers/EveryDaysPicker';

export const FormEveryDaysPicker = ({
  label,
  ...props
}: FieldHookConfig<Entity<number> | null> & IFieldProps) => {
  const [field, meta, helpers] = useField<Entity<number> | null>(props);
  return (
    <>
      <EveryDaysPicker
        name={props.name}
        placeholder={props.placeholder}
        label={label}
        variant="filled"
        onChange={value => {
          helpers.setValue(value, true);
          if (props.onChange) {
            props.onChange(value);
          }
        }}
        info={props.info}
        onBlur={field?.onBlur}
        value={field.value}
        error={meta?.error !== undefined}
        helperText={meta.error}
        fullWidth={props.fullWidth}
      />
    </>
  );
};
